<script setup lang="ts">
import { RouterView, useRoute } from 'vue-router'

const route = useRoute()

// watch(route, () => {
//   console.log(route.name, route.meta.transition || 'fade')
// })
</script>

<template>
  <router-view v-slot="{ Component }">
    <transition :name="route.meta.transition || 'fade'" mode="out-in" appear>
      <component :is="Component" :key="route.fullPath" />
    </transition>
  </router-view>
</template>

<style scoped>
/* ------------------------ */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* ------------------------ */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(-10px);
  opacity: 0;
}
/* ------------------------ */
</style>
